const quickFilters = [
  'sellername=iguasport-ltda',
  'marca-propria=marcas-decathlon',
  'blueproduct=true',
]

export const hasQuickFilters = (url: URL | string) => {
  const search = typeof url === 'string' ? url : url.search

  return quickFilters.some((filter) => search.includes(filter))
}
